import {ENTITLEMENT_KEYS} from '@packages/domains/billing/constants';
import {defineAbilityConfig} from '../system/defineAbilityConfig';

/**
 * Determines whether a user can access granular access features.
 */
export const canAccessGranularAccessFeatures = defineAbilityConfig({
  entitlements: [ENTITLEMENT_KEYS.ALLOW_GRANULAR_ACCESS],
} as const);

export const canAccessStaticPageContentFgac = defineAbilityConfig({
  entitlements: [ENTITLEMENT_KEYS.ALLOW_GRANULAR_ACCESS],
} as const);

export const canAccessLocalesFgac = defineAbilityConfig({
  entitlements: [ENTITLEMENT_KEYS.ALLOW_GRANULAR_ACCESS],
} as const);

/**
 * Determines whether a user can read site membership data.
 * Client workspace-role users may have this permission denied via server-side overrides.
 */
export const canReadSiteMembers = defineAbilityConfig({
  permission: ['read', 'siteMembership'],
} as const);

/**
 * Determines whether the user is in read-only mode.
 * This includes unauthorized users (accessing via shareable links) and anonymous comment users.
 *
 * Read-only mode users can view the Designer but cannot make changes or save.
 */
export const isInReadOnlyMode = defineAbilityConfig({
  userTypes: {
    unauthorized: true,
    anonymousComment: true,
  },
} as const);
